<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay">
      <div class="modal-window">
        <div class="hw-modal-wrap modal-content">
          <div class="hw-modal-header">{{ $t('FAVORITE_SETTING') }}</div>

          <div class="hw-modal-body">
            <ul class="gt-list-dot gt-mb-20">
              <li>{{ $t('BOOKMARK_MSG1') }}</li>
              <li>{{ $t('BOOKMARK_MSG2') }}</li>
            </ul>

            <BookmarkAdd
              :bookmark-add-visible-type="bookmarkAddVisibleType"
              :modify-bookmark-info="modifyBookmarkInfo"
              @set-bookmark-add-visible-type="setBookmarkAddVisibleType"
              @modify-bookmark="modifyBookmark"
              @create-bookmark="createBookmark"
            />

            <div class="hw-sortable-rows gt-mt-15 ui-sortable" ref="bookmarkSort" v-show="bookmarkList.length > 0">
              <div
                class="hw-sortable-row"
                v-for="bookmarkInfo in bookmarkList"
                :key="bookmarkInfo.no"
                v-bind:data-id="bookmarkInfo.no"
              >
                <div class="hw-sortable-col">
                  <div class="btn-handle row-btn-handle gt-pr-20">
                    <i class="fas fa-grip-vertical"></i>
                  </div>
                </div>
                <div class="hw-sortable-col">
                  <div>{{ bookmarkInfo.bookmark.name }}</div>
                  <div>{{ getHttpUrl(bookmarkInfo.bookmark.url) }}</div>
                </div>
                <div class="hw-sortable-col">
                  <button type="button" class="hw-icon modify" @click="setModifyBookmarkInfo(bookmarkInfo)">
                    <i class="fal fa-pen"></i>
                  </button>
                  <button type="button" class="hw-icon delete" @click="removeBookmark(bookmarkInfo.no)">
                    <i class="fal fa-trash-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="hw-modal-footer">
            <button type="button" class="hw-button secondary" @click="setBookmarkOrderSettingVisible(false)">
              {{ $t('CLOSE') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BookmarkAdd from './BookmarkAdd';
import Sortable from 'sortablejs';

export default {
  name: 'MenuOrderSetting',
  data() {
    return {
      modifyBookmarkInfo: {},
    };
  },
  components: {
    BookmarkAdd,
  },
  props: {
    bookmarkAddVisibleType: {
      type: Number,
      required: true,
    },
    bookmarkList: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(() => {
      let bookmarkSort = this.$refs.bookmarkSort;
      let sortable = Sortable.create(bookmarkSort, {
        animation: 250,
        maxLevels: 0,
        onEnd: function() {
          self.modifyBookmarkOrder(sortable.toArray());
        },
      });
    });
  },
  methods: {
    setModifyBookmarkInfo(bookmarkInfo) {
      this.setBookmarkAddVisibleType(3);
      this.modifyBookmarkInfo = bookmarkInfo;
    },
    setBookmarkOrderSettingVisible(isVisible) {
      this.$emit('set-bookmark-add-visible-type', 1);
      this.$emit('set-bookmark-order-setting-visible', isVisible);
    },
    setBookmarkAddVisibleType(type) {
      this.$emit('set-bookmark-add-visible-type', type);
    },
    createBookmark(name, url) {
      this.$emit('create-bookmark', name, url);
    },
    modifyBookmark(no, name, url) {
      this.$emit('modify-bookmark', no, name, url);
    },
    removeBookmark(no) {
      if (confirm(this.$t('REMOVE_CONFIRM'))) {
        this.$emit('remove-bookmark', no);
      }
    },
    modifyBookmarkOrder(noOrderList) {
      this.$emit('modify-bookmark-order', noOrderList);
    },
    getHttpUrl(url) {
      let urlPattern = /^(http|https):/;
      return urlPattern.test(url) ? url : 'http://' + url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/base/variables';
@import 'src/assets/scss/mixins/truncate';
.hw-button {
  display: inline-block;
  background-color: $primary-color;
  border: 1px solid $primary-color-hover;
  border-radius: 4px;
  color: #fff;
  padding: 5px 20px 6px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  transition-duration: 0.1s;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;

  //hover
  &:hover,
  &:focus {
    color: #fff;
    background: darken($primary-color-hover, 10%);
    border-color: darken($primary-color-hover, 10%);
    outline: none;
  }

  //disabled
  &[disabled],
  &:disabled {
    cursor: default;
    opacity: 0.5;
    &:hover {
      background: $primary-color;
      border-color: $primary-color-hover;
    }
  }

  &.secondary {
    background-color: $secondary-color;
    border-color: $secondary-color-hover;
    color: #333;
    &:hover,
    &:focus {
      background-color: $secondary-color-hover;
      border-color: $secondary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $secondary-color;
        border-color: $secondary-color-hover;
      }
    }
  }

  &.info {
    background-color: $info-color;
    border-color: $info-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $info-color-hover;
      border-color: $info-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $info-color;
        border-color: $info-color-hover;
      }
    }
  }

  &.warning {
    background-color: $warning-color;
    border-color: $warning-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $warning-color-hover;
      border-color: $warning-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $warning-color;
        border-color: $warning-color-hover;
      }
    }
  }

  &.danger {
    background-color: $danger-color;
    border-color: $danger-color-hover;
    color: #fff;
    &:hover,
    &:focus {
      background-color: $danger-color-hover;
      border-color: $danger-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        background: $danger-color;
        border-color: $danger-color-hover;
      }
    }
  }

  &.text {
    color: $primary-color;
    padding: 0 10px;
    background: transparent;
    border-color: transparent;
    //hover
    &:hover,
    &:focus {
      color: $primary-color-hover;
    }
    //disabled
    &[disabled],
    &:disabled {
      &:hover {
        color: $primary-color;
        background: transparent;
        border-color: transparent;
        opacity: 0.5;
      }
    }
  }

  &.outline-blue {
    background-color: #fff;
    border: 1px solid #c8c8c8;
    color: #2c86dc;
    &:hover {
      border-color: #2c86dc;
    }
  }

  &.outline-gray {
    background: #f1f1f1;
    border: 1px solid #c8c8c8;
    color: #444;
    &:hover {
      border-color: #8c8c8c;
    }
  }

  &.outline-gray2 {
    background: #fff;
    border: 1px solid #d6d6d6;
    color: #333;
    padding-left: 12px;
    padding-right: 12px;
    > i {
      color: #909090;
      float: right;
      margin-top: 4px;
      margin-left: 10px;
    }
    &:hover {
      background: #f6f6f6;
    }
    &:focus {
      > i {
        color: #575757;
      }
    }
    &[disabled],
    &:disabled {
      border-color: #f2f2f2;
      background: #ffffff;
      &,
      > i {
        color: #d0d0d0;
      }
    }
  }

  &.rounded {
    border-radius: 4px;
  }

  //이웃하는 버튼 간격
  & + .hw-button {
    margin-left: 14px;
  }
}
@mixin sortableItem($cellHeight: 34px, $placeholderColor: #2985db) {
  // drag handle
  .btn-handle {
    display: inline-block;
    visibility: hidden;
    cursor: move; // IE fallback
    cursor: -webkit-grab;
    padding: 10px;
  }

  // 드래그 중인 영역
  &.ui-sortable-helper {
    width: 100%;
    cursor: grabbing;
    cursor: -webkit-grabbing;
  }
  // 가상 드롭 영역
  &.ui-sortable-placeholder {
    visibility: visible !important;
    box-sizing: border-box;
    width: 100%;
    height: $cellHeight;
    border: 1px dashed $placeholderColor;
    margin-top: 5px;
  }
}
.hw-sortable-rows {
  border-top: 1px solid #d6d6d6;
  border-bottom: 1px solid #d6d6d6;
  padding: 5px 0;

  .hw-sortable-row {
    @include sortableItem(69px);
    display: flex;
    align-items: center;
    width: 100%;
    height: 69px;
    color: #676767;
    cursor: grab;

    & + .hw-sortable-row {
      margin-top: 5px;
    }
    &:not(.hw-sortable-disabled):hover {
      background-color: #eff4fc;
      .row-btn-handle {
        visibility: visible;
      }
    }
    &:not(.ui-sortable-placeholder).active {
      background-color: #f8f8f8 !important;
    }
  }

  .hw-sortable-col {
    // url 영역
    &:nth-child(2) {
      flex: 1 1 0;
      -ms-flex: 1 1 auto;
      @include truncateFlexChild();
      .title {
        @include truncate(100%);
        display: block;
      }
      .url {
        @include truncate(100%);
        display: block;
        font-size: 12px;
        margin-top: 5px;
      }
    }

    // 수정, 삭제버튼 영역
    &:nth-child(3) {
      padding-right: 20px;
      text-align: right;
      flex: 90px 0 0;
    }

    .hw-icon {
      width: 32px;
      height: 32px;
    }
  }
}

.modal {
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
  }

  &-window {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  &-content {
    padding: 10px 20px;
  }

  &-footer {
    background: #ccc;
    padding: 10px;
    text-align: right;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s;

  .modal-window {
    transition: opacity 0.2s, transform 0.2s;
  }
}

.modal-leave-active {
  transition: opacity 0.2s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;

  .modal-window {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.hw-modal-header {
  padding-bottom: 20px;
  border-bottom: 1px solid #d6d6d6;
  font-size: 16px;
}

.hw-modal-body {
  padding-top: 20px;
  font-size: 14px;
  // max-height: 580px;
  overflow-y: auto;
}

.hw-modal-footer {
  padding-top: 30px;
  text-align: center;
}

.modal {
  li {
    padding-bottom: 0px !important;
  }
  &.modal-overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 30;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
  }
  .modal-window {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    width: calc(100% - 20px);
    max-height: 80vh;

    @media (min-width: 900px) {
      width: 700px;
      max-height: none;
    }

    .hw-modal-wrap {
      position: inherit;
      top: 50%;
      left: 50%;
      z-index: 1010;
      padding: 25px;
      border: 1px solid #707070;
      background: #fff;
      color: #333;
      box-sizing: border-box;
      width: 100%;
      *,
      *:before,
      *:after {
        box-sizing: inherit;
      }

      .gt-list-dot > li:before {
        color: #909090;
      }

      &.modal-content {
        padding: 25px;
      }
      .hw-modal-header {
        padding-bottom: 20px;
        border-bottom: 1px solid #d6d6d6;
        font-size: 16px;
      }
      .hw-modal-body {
        padding-top: 20px;
        font-size: 14px;
        max-height: calc(100% - 109px);
        overflow-y: auto;

        @media (min-width: 900px) {
          max-height: 580px;
        }
        .hw-sortable-rows {
          &.ui-sortable {
          }
          .hw-sortable-row {
            .hw-sortable-col {
              .btn-handle {
                &.row-btn-handle {
                }
              }
              .hw-icon {
                width: 32px;
                height: 32px;
                &.modify {
                }
                &.delete {
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
